import React from "react";
import AppBar from "@mui/material/AppBar";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { RefineThemedLayoutV2HeaderProps } from "@refinedev/mui";
import { SidebarToggle } from "../Header";
import { AdminUserMenu } from "./AdminUserMenu";

// Header of the admin area: same AppBar and sidebar toggle as the seller
// Header, without the seller-only controls (order search, store selector,
// marketplace clock, workspace drawer).
export const AdminHeader: React.FC<RefineThemedLayoutV2HeaderProps> = ({
  sticky = false,
}) => (
  <AppBar position={sticky ? "sticky" : "relative"}>
    <Toolbar>
      <SidebarToggle />
      <Box sx={{ flexGrow: 1 }} />
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        gap={3}
        sx={{ flexShrink: 0 }}
      >
        <Box sx={{ width: 220 }}>
          <AdminUserMenu />
        </Box>
      </Stack>
    </Toolbar>
  </AppBar>
);
